<template>
  <v-tooltip v-bind="$attrs" v-model="showTooltip">
    <template #activator="{ attrs, on }">
      <div :class="['flex', ...wrapperClass]" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
        <slot name="activator" v-bind="attrs" v-on="on" />
      </div>
    </template>
    <div
      @mouseenter="interactive && toggleHoverTooltip(true)"
      @mouseleave="interactive && onMouseLeaveTooltip()"
    >
      <slot />
    </div>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent, PropType, toRef } from 'vue';
import { useToggle } from '@/composables/useToggle';

export default defineComponent({
  name: 'CfsTooltip',
  props: {
    interactive: {
      type: Boolean,
      default: false,
    },
    closeDelay: {
      type: Number,
      default: 200,
    },
    wrapperClass: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props) {
    const [showTooltip, toggleTooltip] = useToggle(false);
    const [hoverTooltip, toggleHoverTooltip] = useToggle(false);
    const closeDelay = toRef(props, 'closeDelay');

    const onMouseEnter = () => toggleTooltip(true);
    const onMouseLeave = () => {
      setTimeout(() => {
        if (hoverTooltip.value) return;
        else toggleTooltip(false);
      }, closeDelay.value);
    };

    const onMouseLeaveTooltip = () => {
      toggleHoverTooltip(false);
      onMouseLeave();
    };

    return {
      showTooltip,
      hoverTooltip,
      onMouseLeaveTooltip,
      toggleHoverTooltip,
      onMouseLeave,
      onMouseEnter,
    };
  },
});
</script>

<style lang="scss" scoped>
.custom-scale-transition {
  &-leave-active {
    transform: scaleX(1);
  }

  &-enter-active,
  &-leave,
  &-leave-to {
    transition: transform 0.2s ease-in-out;
    transform-origin: left center;
  }

  &-enter,
  &-leave-to {
    transform: scaleX(0);
  }
}

.custom-fade-transition {
  &-leave-active {
    opacity: 100%;
  }

  &-enter-active,
  &-leave,
  &-leave-to {
    transition: opacity 0.35s;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
}
</style>
